import React, { useEffect } from "react";
import Header from "../common/Header";
import hero_top_bg_mobile from "../../assets/images/png/hero_top_bg_mobile.png";
import hero_top_bg from "../../assets/images/png/hero_top_bg.png";
import hero_piller_img_mobile from "../../assets/images/png/hero_piller_img_mobile.png";
import hero_piller_img from "../../assets/images/png/hero_piller_img.png";
import hero_flowers_mobile from "../../assets/images/png/hero_flowers_mobile.png";
import hero_temple from "../../assets/images/webp/hero_temple.webp";
import Button from "../common/button/Button";
import { Link, useLocation } from "react-router-dom";
const HeaderOnly = () => {
  const { pathname } = useLocation();
  let location = useLocation();

  console.log(location.hash, "pathname")
  useEffect(() => {
    if (location.hash) {
      const section = document.getElementById("register");
      if (section) {
        window.scrollTo({
          top: section.offsetTop,
          behavior: "smooth"
        });
      }
    }
    // Scroll to the specific section with the id "fromregister" when the component mounts

  }, []);
  return (
    <>
      <div className="headeronly_section text-white d-flex align-items-end align-items-lg-center justify-content-center py-5 bg_orange">
        <Header /> 
      </div>
    </>
  );
};

export default HeaderOnly;
